<template>
  <div class="mdw-fixed mdw-top-4 mdw-right-4 mdw-z-50" v-if="notificacao.length > 0">
    <TransitionGroup
      name="list"
      tag="div"
      class="mdw-flex mdw-items-start mdw-gap-4 mdw-flex-col"
    >
      <ToastComponent
        v-for="notification in notificacao"
        :key="notification.id"
        :id="notification.id"
        :message="notification.message"
        :type="notification.type"
        :duration="notification.duration"
        @close="removeNotificationById(notification.id)"
      />
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { useNotification } from "../../../composables/useNotification";
import ToastComponent from "./ToastComponent.vue";

interface Notification {
  id: number;
  message: string;
  type: "success" | "error" | "warning" | "info";
  duration?: number;
}

const { notifications, removeNotificationById } = useNotification();

const notificacao = computed(() => notifications.value);
</script>